export const COMMUNITY_NETWORK_QUERY = '/community-network';
export const CLIENT_NETWORK_CONFIG_QUERY = '/client-network/v2/config';
export const COMMUNITY_CONCENTRATION_RISK_STATS_QUERY = '/community-network/organisations/stats';
export const CLIENT_NETWORK_QUERY = '/client-network';
export const CLIENT_NETWORK_LIST_QUERY = '/client-network/list';
